<template>
  <div>

    <!-- TODO: this should also handle exceptions -->
    
<FormKitLazyProvider>
<div v-if="submitted" class="message message-success submission">
      {{ $texts('webform.submission', 'Erfolgreich versendet') }}
    </div>

    <FormKit type="form" :actions="false" @submit="submitWebform">
      <div v-for="formElement in formDefinition?.elements" :key="formElement?.key">

        <!-- Flexbox Element -->

        <div v-if="formElement.type === 'webform_flexbox'" class="etx-flex Flex gv-150">
          <div v-for="formChildElement in formElement?.elements" :key="formChildElement?.key"
            class="etx-flex__item Flex__item tab-s:c-6">
            <FormKit :type="formTypeMatcher[formChildElement?.type]" :name="formChildElement?.key"
              :label="formChildElement?.type === 'select' ? null : formChildElement?.title || 'Default Title'"
              :help="cleanDescription(formChildElement?.description)"
              :placeholder="formChildElement?.type === 'select' ? formChildElement?.title : formChildElement?.placeholder"
              :options="prepareOptions(formChildElement?.options)" :required="formChildElement?.required" :attributes="{
                required: formChildElement?.required || null,
                pattern: formChildElement?.pattern?.rule || null
              }" :wrapperClass="getWrapperClass(formChildElement, true)" :innerClass="'FormField__input'"
              :messageClass="'font-color-primary font-size-small'" />
          </div>
        </div>

        <!-- Single Checkbox Element -->
        <FormKit v-else-if="formElement.type === 'checkbox'" type="checkbox" :name="formElement?.key" :multiple="false"
          :required="formElement?.required || false" :outerClass="'FormField checkbox'"
          :wrapperClass="'FormField__input'" :innerClass="'FormField__input__option'"
          :helpClass="'font-color-primary font-size-small'" :messageClass="'font-color-primary font-size-small'">
          <!-- Custom Label with HTML Rendering -->
          <template #label>
            <span v-html="formElement?.title"></span>
          </template>
        </FormKit>

        <!-- Checkboxes Group -->
        <FormKit v-else-if="formElement.type === 'checkboxes'" type="checkbox" :name="formElement?.key"
          :label="formElement?.title" :options="prepareOptions(formElement.options)" :attributes="{
            required: formElement?.required || null,
            pattern: formElement?.pattern?.rule || null
          }" :outerClass="'mb-4'" :inputClass="'h-5 w-5 text-blue-600 border-gray-300 rounded'"
          :labelClass="'text-gray-700 mb-1 ml-2'" :optionClass="'text-gray-700 cursor-pointer'"
          :wrapperClass="'flex items-center'" :legendClass="'font-medium mb-2'"
          :helpClass="'font-color-primary font-size-small'" :messageClass="'font-color-primary font-size-small'" />

        <!-- Radios Group -->
        <FormKit v-else-if="formElement.type === 'radios'" type="radio" :name="formElement?.key"
          :label="formElement?.title" :options="prepareOptions(formElement.options)" :outerClass="'mb-4'"
          :inputClass="'h-5 w-5 text-blue-600 border-gray-300 focus:ring-2 focus:ring-blue-500 rounded-full'"
          :labelClass="'text-gray-700 mb-1 ml-2'" :optionClass="'text-gray-700 cursor-pointer'"
          :wrapperClass="'flex items-center'" :legendClass="'font-medium mb-2'"
          :helpClass="'font-color-primary font-size-small'" :messageClass="'font-color-primary font-size-small'" />

        <!-- Select Element -->
        <FormKit v-else-if="formElement.type === 'select'" type="select" :name="formElement?.key" :label="null"
          :options="prepareOptions(formElement.options)" :attributes="{
            pattern: formElement?.pattern?.rule || null
          }" :multiple="Boolean(formElement.multiple)" :placeholder="formElement?.title"
          :wrapperClass="getWrapperClass(formElement, true)" :innerClass="'FormField__input'"
          :messageClass="'font-color-primary font-size-small'" :validation="getValidationRules(formElement)" />

        <!-- File Element -->
        <FormKit v-else-if="formElement.type === 'managed_file'" type="file" :name="formElement?.key"
          :label="formElement?.title" :help="cleanDescription(formElement?.description)" :attributes="{
            required: formElement?.required || null,
            pattern: formElement?.pattern?.rule || null
          }" :multiple="Boolean(formElement.multiple)"
          :accept="formElement.fileExtensions.split(' ').map(ext => '.' + ext).join(', ')" :outerClass="'mb-4'"
          :inputClass="'w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'"
          :labelClass="'block text-gray-700 font-medium mb-2'" :helpClass="'font-color-primary font-size-small'"
          :messageClass="'font-color-primary font-size-small'" :noFilesClass="'hidden'"
          :fileRemoveClass="'w-full flex justify-end text-xs text-error-500 font-medium'" />

        <!-- File (specific/alternative) Element -->
        <FormKit v-else-if="formElement.type === 'webform_document_file'" type="file" :name="formElement?.key"
          :label="formElement?.title" :help="cleanDescription(formElement?.description)" :attributes="{
            required: formElement?.required || null,
            pattern: formElement?.pattern?.rule || null
          }" :multiple="Boolean(formElement.multiple)" :outerClass="'mb-4'"
          :inputClass="'w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500'"
          :labelClass="'block text-gray-700 font-medium mb-2'" :helpClass="'font-color-primary font-size-small'"
          :messageClass="'font-color-primary font-size-small'" :noFilesClass="'hidden'"
          :fileRemoveClass="'w-full flex justify-end text-xs text-error-500 font-medium'" />

        <!-- Textfield -->
        <FormKit v-else-if="formElement.type === 'textfield'" type="text" :name="formElement?.key"
          :label="formElement?.title" :attributes="{
            required: formElement?.required || null,
            pattern: formElement?.pattern?.rule || null
          }" :placeholder="formElement?.placeholder" :wrapperClass="getWrapperClass(formElement)"
          :innerClass="'FormField__input'" :helpClass="'font-color-primary font-size-small'"
          :messageClass="'font-color-primary font-size-small'" />

        <!-- Textarea -->
        <FormKit v-else-if="formElement.type === 'textarea'" type="textarea" :name="formElement?.key"
          :label="formElement?.title" :placeholder="formElement?.placeholder" :required="formElement?.required || false"
          :attributes="{
            pattern: formElement?.pattern?.rule || null
          }" :wrapperClass="getWrapperClass(formElement)" :outerClass="'etx-flex__item Flex__item'"
          :innerClass="'FormField__input'" :helpClass="'font-color-primary font-size-small'"
          :messageClass="'font-color-primary font-size-small'" />

        <!-- Submit Button -->
        <FormKit v-else-if="formElement.type === 'webform_actions'" type="submit" suffix-icon="check"
          :label="formElement?.submitLabel" :outerClass="'submit-button'" :wrapperClass="'FormSubmit'"
          :inputClass="'etx-button Button focus color-primary'" :labelClass="'testi'" />

        <!-- Markup -->
        <FormKit v-else-if="formElement.type === 'webform_markup'" type="text" :outerClass="'markup-element'"
          :innerClass="'markup-inner'">
          <!-- Custom Label with HTML Rendering -->
          <template #label>
            <span v-html="formElement?.markup"></span>
          </template>
        </FormKit>

        <!-- Standard Element -->
        <FormKit v-else :type="formTypeMatcher[formElement?.type]" :name="formElement?.key" :label="formElement?.title"
          :help="cleanDescription(formElement?.description)" :placeholder="formElement?.placeholder"
          :options="prepareOptions(formElement?.options)" :validation="getValidationRules(formElement)"
          :wrapperClass="'FormField text'" :innerClass="'FormField__input'"
          :messageClass="'font-color-primary font-size-small'" />
      </div>
    </FormKit>
</FormKitLazyProvider>

  </div>
</template>

<script lang="ts" setup>
import { FormKitLazyProvider } from '@formkit/vue'
const props = defineProps<{
  formId?: string
}>()

const { $texts } = useNuxtApp()
const contactForm = ref<HTMLFormElement | null>(null);
const route = useRoute()
const submitted = ref(false)

// Validation
function enforceValidation(event: Event) {
  const form = event.target as HTMLFormElement;
  if (form && !form.checkValidity()) {
    event.preventDefault();
    form.reportValidity();
  }
}

const { data: formDefinition } = await useAsyncData(`drupalWebform-${props?.formId}`, async () => {
  return await useGraphqlQuery('webformById', {
    id: props?.formId,
  }).then((v) => v?.data?.entityById)
})

// TODO: improve events handling with `prevent` and Vue's bindings
onMounted(() => {
  if (contactForm.value) {
    contactForm.value.addEventListener('submit', enforceValidation);
  }
});

onUnmounted(() => {
  if (contactForm.value) {
    contactForm.value.removeEventListener('submit', enforceValidation);
  }
});

onMounted(() => {
  if (Object.keys(route.query).length > 0) {
    // Match route query params with data
    for (const key in route.query) {
      // if (formDefinition.value.hasOwnProperty(key)) {
        // formDefinition.value[key] = route.query[key];
      // }
    }
  }
})

async function submitWebform(data) {
  let elements = [];
  for (const property in data) {
    const value = data[property];

    if (value || value === 0) {
      elements.push({
        'element': property,
        'value': value,
      });
    }
  }

  await useGraphqlMutation("submitWebform", { id: props?.formId, elements: elements });

  localStorage.setItem('formSubmitted', 'true');

  window.location.reload();
}

onMounted(() => {
  if (localStorage.getItem('formSubmitted') === 'true') {
    submitted.value = true;
    setTimeout(() => {
      localStorage.removeItem('formSubmitted');
    }, 2000);
  }
});

// Rules
function getValidationRules(element) {
  const rules = [];
  if (element?.required) {
    rules.push("required");
  }
  if (element?.type === 'email') {
    rules.push("email");
  }
  if (element?.type === 'date') {
    rules.push("date_format:YYYY-MM-DD");
  }
  if (element.pattern?.rule) {
    rules.push(`matches:${element.pattern.rule}`);
  }
  if (element?.type === 'managed_file' && element.fileExtensions) {
    rules.push((value) => validateFileExtension(value, element) || `Only the following extensions are allowed: ${element.fileExtensions}`);
  }
  return rules.join('|');
}

// File validation
function validateFileExtension(value, element) {
  if (!element.fileExtensions) return true;

  const allowedExtensions = element.fileExtensions.split(" ");

  const files = Array.isArray(value) ? value : [value];
  return files.every(file => {
    const fileExtension = file.name.split('.').pop();
    return allowedExtensions.includes(fileExtension);
  });
}

// Format options
function prepareOptions(options) {
  if (!options) return [];
  return options.map(option => ({
    label: option.title,
    value: option.value
  }));
}

// Format description
function cleanDescription(description) {
  if (!description) return "";  // Falls keine Beschreibung vorhanden ist
  return description.replace(/<[^>]*>/g, '');  // Entfernt alle HTML-Tags
}

// Dynamic wrapper class
function getWrapperClass(formElement, isInFlexbox = false) {
  let baseClass = '';
  if (formElement.type === 'select') {
    baseClass = isInFlexbox ? 'etx-flex__item FormField select' : 'FormField select';
  } else if (['textfield', 'textarea'].includes(formElement.type)) {
    baseClass = isInFlexbox ? 'etx-flex__item FormField text' : 'FormField text';
  } else {
    baseClass = 'FormField';
  }

  // Required class
  if (formElement.required) {
    baseClass += ' required-element';
  }

  return baseClass;
}

const formTypeMatcher = {
  'textfield': 'text',
  'textarea': 'textarea',
  'email': 'email',
  'phone': 'tel',
  'date': 'date',
  'radios': 'radio',
  'select': 'select',
  'checkbox': 'checkbox',
  'checkboxes': 'checkbox',
  'managed_file': 'file',
  'webform_document_file': 'file',
  'webform_actions': 'submit',
}
</script>

<style>
.formkit-outer.etx-flex__item.Flex__item,
.formkit-outer.FormField.checkbox {
  margin-top: 45px;
}

.formkit-message {
  list-style: none;
}

/* Validation  */
.formkit-wrapper.required-element>label::after {
  content: "*";
  margin-left: 5px;
  color: var(--color-primary-100);
}

/* Checkbox custom styling */
.FormField.checkbox .FormField__input {
  flex-flow: row nowrap;
  align-items: flex-start;
  display: flex;
  margin: 0px;
  padding: 0px;
  cursor: pointer;
}

.FormField.checkbox .FormField__input input[type="checkbox"] {
  -webkit-appearance: none;
  flex: 0 0 auto;
  width: var(--formfield-checkbox-size);
  height: var(--formfield-checkbox-size);
  min-width: var(--formfield-checkbox-size);
  min-height: var(--formfield-checkbox-size);
  position: relative;
  margin-right: 15px;
  margin-top: calc((var(--line-height) - var(--formfield-checkbox-size)) / 2);
  padding: 0px;
  border: 1px solid var(--color-secondary-40);
  border-radius: 2px;
  transition: background-color 0.4s var(--transition-timing);
}

.FormField.checkbox .FormField__input:hover input[type="checkbox"]:not(:checked) {
  background-color: var(--color-secondary-20);
}

.FormField.checkbox .FormField__input input[type="checkbox"]:checked {
  border: 1px solid var(--color-secondary-100);
  background-color: var(--color-secondary-100);
}

.FormField.checkbox .FormField__input input[type="checkbox"]:checked:after {
  content: "";
  position: absolute;
  left: 50%;
  top: 50%;
  font-family: "Font Awesome 6 Pro";
  font-weight: 400;
  font-size: 0.7em;
  color: var(--color-bg);
  transform: translate(-50%, -50%);
}

.FormField.checkbox .FormField__input span {
  --color-fg: var(--color-text-medium);
  color: var(--color-fg);
}

/* Markup */
.markup-element {
  margin-top: var(--etx-container-padding-v-50);
  margin-bottom: var(--etx-container-padding-v-25);
}

.markup-element p {
  margin: 0;
  font-weight: 700;
  --line-height: 1.4em;
  font-size: 1.2em;
  line-height: var(--line-height);
}

.markup-inner {
  display: none;
}

/* Button */
.formkit-input.Button .formkit-suffix-icon {
  margin-left: 1.5em;
  min-height: 0px;
  line-height: 1.25em;
  transform: translateX(0px);
  transition: transform 0.4s var(--transition-timing);
  flex: 0 0 auto;
}

.formkit-input.Button .formkit-suffix-icon svg {
  display: none;
}

.formkit-input.Button .formkit-suffix-icon:before {
  content: "\f178";
  font-family: 'Font Awesome 6 Pro';
  font-size: 0.85em;
  font-weight: 400;
}

.formkit-input.Button {
  font-weight: 700;
  margin-top: 45px;
}

.formkit-input.Button:hover .formkit-suffix-icon {
  transform: translateX(5px);
}

/* Submission */
.submission {
  margin-bottom: 60px;
}

.message {
    margin-top: 1rem;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 1em;
    background-color: transparent;

    &.message-success {
        color: #3a4a18;
        background-color: rgb(233 241 216 / 1);
        border-color: currentColor;
    }
}
</style>
